module.exports = __webpack_public_path__ + "media/product/instagram-1-84884688.jpg";